import _classCallCheck from "babel-runtime/helpers/classCallCheck";
var destinationType;
(function (destinationType) {
    destinationType[destinationType["base64"] = 2] = "base64";
    destinationType[destinationType["url"] = 1] = "url";
})(destinationType || (destinationType = {}));
export var ImagePickerInfo = function ImagePickerInfo() {
    _classCallCheck(this, ImagePickerInfo);

    this.eventType = '';
    this.list = [];
};
export var ImageInfo = function ImageInfo() {
    _classCallCheck(this, ImageInfo);
};
export var Exif = function Exif() {
    _classCallCheck(this, Exif);
};
export var TransPathInfo = function TransPathInfo() {
    _classCallCheck(this, TransPathInfo);
};
export var OpenCameraInfo = function OpenCameraInfo() {
    _classCallCheck(this, OpenCameraInfo);
};
export var TransInfo = function TransInfo() {
    _classCallCheck(this, TransInfo);
};